module.exports = __webpack_public_path__ + "02_short_grey.2be324a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_short_grey.png
// module id = tHL+
// module chunks = 0